import React from "react";
import { useForm, FormProvider } from "react-hook-form";
import { Stepper, Step } from "ui";
import { Business } from "./components/forms/business";
import { Bank } from "./components/forms/bank";
import { useAppSelector } from "../../store";
import { AuthenticationForm } from "./components/forms/authentication";
import { Link } from "react-router-dom";
import { PlusCircleFill } from "react-bootstrap-icons";
import { status } from "interface";

export const Authentication = () => {
  const methods = useForm();
  const { userState, userStateDetail } = useAppSelector(
    (state) => state.dashboard
  );
  const steps = (key: status) => {
    switch (key) {
      case "AUTHENTICATION":  return 1;
      case "CREATEBUSINESS":  return 2;
      case "RECEIVE_IPG":  return 3;
      case "REGISTER":  return 0;
    }
  };
  return (
    <>
      <FormProvider {...methods}>
        <form>
          <Stepper
            activeKey={steps(userState)}
            inProgress={userStateDetail === "PENDING"}
            className="w-100"
          >
            <Step
              stepKey={0}
              step={"مرحله اول"}
              title={"ثبت نام"}
              description={"ثبت نام توضیحات"}
            >
              "مرحله اول"
            </Step>
            <Step
              stepKey={1}
              step={"مرحله دوم"}
              title={"اهراز هویت"}
              description={" اهراز هویت توضیحات"}
            >
              <AuthenticationForm />
            </Step>
            <Step
              stepKey={2}
              step={"مرحله سوم"}
              title={"ایجاد کسب و کار"}
              description={" کسب و کار توضیحات "}
            >
              <Business />
            </Step>
            <Step
              stepKey={3}
              step={"مرحله پایانی"}
              title={"درگاه بانکی"}
              description={"توضیحات درگاه بانکی"}
            >
              {userStateDetail === "APPROVED" ? (
                <div className="p-3">
                  <Link className="d-flex gap-2 " to={"/new-business"}>
                    <h1>ایجاد کسب و کار جدید </h1>
                    <PlusCircleFill color="var(--primary)" size={25} />
                  </Link>
                </div>
              ) : (
                <Bank />
              )}
            </Step>
          </Stepper>
        </form>
      </FormProvider>
    </>
  );
};
